import React, { useEffect } from 'react';
import { View } from 'react-native';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useRoute } from '@react-navigation/native';

import ServiceNoteButton from '../driver/components/ServiceNoteButton';
import { app as appActions } from '../../actions';
import { ROLE_PERMISSIONS } from '../../../common/constants';
import { useUserContext } from '../../../common/utils/context';
import { GET_LOCATION_NOTES, MODIFY_LOCATION } from '../../../common/graphql/location';

import { Dialog } from '../../components';
import { Screen, SecondaryButton } from '../../design/components';
import PageHeading from '../../design/components/PageHeading';
import { DetailContainer } from '../../containers';
import useThemedStyles from '../../hooks/useThemedStyles';
import { NoteList, NoteCreatorView, NoteDetailView } from '../note';

const LocationNotesRaw = ({
	data: location,

	closeDialog,
	openDialog,

	refetch,
}) => {
	const styles = useThemedStyles(createStyles);
	const { hasPermission } = useUserContext();

	const onCreateNote = () => {
		closeDialog();
		if (refetch) {
			refetch();
		}
	};

	const onClickAddNote = () => {
		openDialog(() => (
			<NoteCreatorView
				onSubmitSuccess={onCreateNote}
				showImportant={true}
				initialValues={{ location: location.id }}
			/>
		));
	};

	const onClickEditNote = (note) => {
		openDialog(() => (
			<NoteDetailView
				data={note}
				showImportant={true}
			/>
		));
	};

	// remove the dialog when unmounting
	useEffect(() => {
		return () => {
			closeDialog();
		};
	}, [closeDialog]);

	return (
		<View style={styles.container}>
			<PageHeading
				title="Location notes"
				style={styles.heading}
				action={hasPermission(ROLE_PERMISSIONS.ADD_EDIT_NOTES) && (
					<SecondaryButton label="Add note" icon="plus" onPress={onClickAddNote} />
				)}
			/>
			<NoteList
				items={location.notes}
				refetchList={refetch}
				onClickEditNote={onClickEditNote}
			/>
			<Dialog />
		</View>
	);
};


const mapDispatchToProps = dispatch => ({
	openDialog: component => dispatch(appActions.openDialog(component)),
	closeDialog: () => dispatch(appActions.closeDialog()),
});

const LocationNotes = compose(
	DetailContainer,
	connect(null, mapDispatchToProps),
)(LocationNotesRaw);

const LocationNotesView = () => {
	const route = useRoute();
	const locationId = route.params?.locationId;

	return (
		<Screen headerRight={<ServiceNoteButton />} scroll={false}>
			<LocationNotes
				id={locationId}
				query={GET_LOCATION_NOTES}
				modifyMutation={MODIFY_LOCATION}
			/>
		</Screen>
	);
};

const createStyles = ({ ui: { space } }) => ({
	container: {
		flex: 1,
	},
	heading: {
		paddingHorizontal: space.gutter,
		paddingTop: 20,
	},
});

export default LocationNotesView;
